"use strict";
// packages/contracts/src/painel-blocos.ts — Fase 16.1, Plano 01 (D-07, D-12, D-18, D-20, D-21, D-23).
// Contrato dos seis blocos do painel por perfil: um endpoint por bloco (GET /api/v1/painel/blocos/:id).
// Regras transversais:
//  - cada indicador é uma contagem medida no servidor; nenhum tipo carrega valor monetário (ASVS V8; D-08);
//  - campo ausente na resposta significa "sem permissão para ver"; nunca é zero (D-12);
//  - `INDISPONIVEL` significa que a consulta daquele indicador falhou (o resto do bloco continua válido);
//  - `SEM_MEDICAO` só existe para materiais abaixo do mínimo (D-22).
Object.defineProperty(exports, "__esModule", { value: true });
exports.ID_BLOCOS_PAINEL = void 0;
/** Ordem fixa dos blocos no painel (D-02). */
exports.ID_BLOCOS_PAINEL = ['pcp', 'qualidade', 'almoxarifado', 'compras', 'faturamento', 'visao-geral'];
//# sourceMappingURL=painel-blocos.js.map